import React, { useState } from "react";
import Swal from "sweetalert2";

function NewBilling() {
  const [submitted, setSubmitted] = useState(false);
  const [selectFiveOptions, setSelectFiveOptions] = useState([]);
  const [formData, setFormData] = useState({
    cliente: "",
    usoCfdi: "",
    condicionesPago: "",
    metodoPago: "",
    cuentaPago: "",
    observaciones: "",
  });

  const handleFormChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleCondicionesPagoChange = (e) => {
    const value = e.target.value;
    handleFormChange("condicionesPago", value);

    if (value === "opcion1") {
      setSelectFiveOptions(["Subopcion 1", "Subopcion 2"]);
    } else if (value === "opcion 2") {
      setSelectFiveOptions(["Subopcion A", "Subopcion B"]);
    } else {
      setSelectFiveOptions([]);
    }
  };

  const billingDetails = [
    { concepto: "Reporte de temperatura", monto: "350.00" },
  ];

  const validarFormulario = () => {
    const camposRequeridos = [
      "cliente",
      "usoCfdi",
      "condicionesPago",
      "metodoPago",
    ];

    for (const campo of camposRequeridos) {
      if (!formData[campo]) {
        return false;
      }
    }

    return true;
  };

  const handleGuardar = () => {
      setSubmitted(true);
  
      if (!validarFormulario()) {
        Swal.fire({
          title: "Campos incompletos",
          text: "Por favor completa todos los campos obligatorios antes de continuar.",
          icon: "warning",
          iconColor: "#FFA500",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
        return;
      }
  
      console.log("Datos del formulario:", formData);
      facturaAlert();
    //   setView("show");
    };

    const facturaAlert = () => {
        Swal.fire({
          title: "Éxito",
          text: "Factura generada con éxito",
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      };

      const printTicket = () => {
          const now = new Date();
          const fechaHora = now.toLocaleString("es-MX");
      
          // Datos ficticios
          const detalles = [
            { concepto: "Manejo de carga", monto: 259.5 },
            { concepto: "Screening", monto: 45.5 },
          ];
      
          const subtotal = 305.0;
          const iva = 48.8;
          const total = 353.8;
      
          const totalEnLetra =
            "Trescientos cincuenta y tres pesos con ochenta centavos";
      
          const tableRows = detalles
            .map(
              (item) => `
              <tr>
                <td style="text-align: start;">${item.concepto}</td>
                <td style="text-align: center;">$${parseFloat(item.monto).toFixed(
                  2
                )}</td>
              </tr>
            `
            )
            .join("");
      
          const htmlContent = `
              <div id="ticketContent" style="font-family: Arial, sans-serif; text-align: left; padding: 10px;">
                <h3 class="no-print" style="text-align: start; margin-bottom: 10px;"><strong>Ticket Salida</strong></h3>
                <div style="text-align: center; margin-bottom: 10px;">
                  <img src="/img-Ticket-Billing/logo-azul.svg" alt="Imagen-Aeromexico" style="height: 60px;" />
                </div>
          
                <hr style="border: 1px solid black;" />
          
                <p style="text-align: center;">Aerovías de México S.A de C.V.</p>
                <p style="text-align: center;">AME123456I89</p>
                <p style="text-align: center;">Col. Cuauhtémoc, C.P. 06500, Ciudad de México</p>
                <p style="text-align: center;">Paseo de la Reforma 243 Piso 25</p>
          
                <hr style="border: 1px solid black;" />
                <p style="text-align: center;">Ciudad de México, ${fechaHora}</p>
                <hr style="border: 1px solid black;" />
          
                <p style="text-align: center; font-weight: bold;">Folio: 1234567</p>
          
                <p><strong>Master:</strong> 123-45678901</p>
                <p><strong>Valor aduana:</strong> $5,000.00</p>
                <p><strong>House:</strong> 987654321</p>
                <p><strong>Piezas:</strong> 10</p>
                <p><strong>Peso:</strong> 250 kg</p>
                <p><strong>Agente/Almacén:</strong> LOGISTIK SA DE CV</p>
          
                <hr style="border: 1px solid black;" />
          
                <table class="table fondo-headBillingMonto">
                  <thead>
                    <tr>
                      <th style="border-bottom: 1px solid #000;">Cargo</th>
                      <th style="border-bottom: 1px solid #000;">Importe</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${tableRows}
                    <tr class="bor-bot">
                      <td style="font-weight: bold; text-align: center;">Subtotal</td>
                      <td style="text-align: center;">$${subtotal.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold; text-align: center;">IVA 16%</td>
                      <td style="text-align: center;">$${iva.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold; text-align: center;">Total</td>
                      <td style="text-align: center;">$${total.toFixed(2)}</td>
                    </tr>
                  </tbody>
                </table>
          
                <hr style="border: 1px solid black;" />
                <p style="text-align: left; text-transform: uppercase;"><small>(${totalEnLetra} / 100 M.N.)</small></p>
          
                <h3 style="text-align: left;">Datos a facturar</h3>
                <p style="text-align: left;">Cliente</p>
                <p><strong>Nombre:</strong> Transportes Globales MX</p>
                <p><strong>RFC:</strong> TGM123456ABC</p>
                <p><strong>Uso CFDI:</strong> G03 - Gastos en general</p>
                <p><strong>Condiciones de pago:</strong> Contado</p>
                <p><strong>Método de pago:</strong> PUE - Pago en una sola exhibición</p>
                <p><strong>Cuenta de pago:</strong> 1234</p>
                <p><strong>Observaciones:</strong> Ninguna</p>
                <p><strong>Usuario:</strong> Ezequiel Bernal</p>
          
                <hr style="border: 1px solid black;" />
                <p style="text-align: center;">FIRMA</p>
          
                <div style="text-align: right; margin-top: 30px;">
                  <button id="btn-imprimir-ticket" class="btnn">
                    Imprimir
                  </button>
                </div>
              </div>
            `;
      
          Swal.fire({
            title: "",
            html: htmlContent,
            showConfirmButton: false,
            customClass: {
              popup: "ticket-modal",
            },
            width: 500,
      
            didOpen: () => {
              const btnImprimir = document.getElementById("btn-imprimir-ticket");
              if (btnImprimir) {
                btnImprimir.addEventListener("click", () => {
                  const content = document.getElementById("ticketContent").innerHTML;
                  const printWindow = window.open("", "", "width=800, height=900");
                  printWindow.document.write(`<html>
                  <head>
                    <title>Imprimir Ticket</title>
                    <style>
                      body { font-family: Arial, sans-serif; padding: 10px; }
                      table { width: 100%; border-collapse: collapse; }
                      th, td { padding: 4px; }
                      hr { border: 1px solid black; }
                      button { display: none; } /* Ocultar botón al imprimir */
                      @media print {
                      .no-print {
                      display: none !important;
                      }
                      }
                    </style>
                  </head>
                  <body>
                    ${content}
                  </body>
                </html>`);
                  printWindow.document.close();
                  printWindow.focus();
                  printWindow.print();
                  printWindow.close();
                });
              }
            },
          });
        };

  return (
    <>
      <div className="container-fluid">
        {/* primer fila (solo se muestran los datos de la guia)*/}
        <div className="row">
          <div className="col-12 mt-4">
            <div className="row">
              {[
                { label: "Guía Master", value: "ABC123" },
                { label: "Piezas", value: "500" },
                { label: "Peso", value: "100" },
              ].map((item, index) => (
                <div
                  key={index}
                  className={`pb-3 pb-md-5 ${
                    item.label === "Tipo de mercancía" ? "col-md-3" : "col-md-3"
                  }`}
                >
                  <span className="fw-bold">{item.label}: </span>
                  {item.value}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* segunda fila que tienen 5 selects, 3 inputs*/}
        <div className="row mb-4">
          <div className="col-md-3 mb-3">
            <label className="fw-bold">Cliente *</label>
            <select
              className={`form-select ${
                submitted && !formData.cliente ? "is-invalid" : ""
              }`}
              value={formData.cliente}
              onChange={(e) => handleFormChange("cliente", e.target.value)}
            >
              <option value="" disabled>
                Selecciona...
              </option>
              <option value="opX">Opción X</option>
              <option value="opY">Opción Y</option>
            </select>
            {submitted && !formData.cliente && (
              <div className="invalid-feedback">Campo requerido</div>
            )}
          </div>

          <div className="col-md-3 mb-3">
            <label className="fw-bold">Condiciones de pago *</label>
            <select
              className={`form-select ${
                submitted && !formData.condicionesPago ? "is-invalid" : ""
              }`}
              value={formData.condicionesPago}
              onChange={handleCondicionesPagoChange}
            >
              <option value="" disabled>
                Selecciona...
              </option>
              <option value="opcion1">Opción 1</option>
              <option value="opcion2">Opción 2</option>
            </select>
            {submitted && !formData.condicionesPago && (
              <div className="invalid-feedback">Campo requerido</div>
            )}
          </div>

          <div className="col-md-3 mb-3">
            <label className="fw-bold">Forma de pago *</label>
            <select
              className={`form-select ${
                submitted && !formData.metodoPago ? "is-invalid" : ""
              }`}
              value={formData.metodoPago}
              onChange={(e) => handleFormChange("metodoPago", e.target.value)}
              disabled={!selectFiveOptions.length}
            >
              <option value="" disabled>
                Selecciona...
              </option>
              {selectFiveOptions.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {submitted && !formData.metodoPago && (
              <div className="invalid-feedback">Campo requerido</div>
            )}
          </div>

          <div className="col-md-3 mb-3">
            <label className="fw-bold">Uso del CFDI *</label>
            <select
              className={`form-select ${
                submitted && !formData.usoCfdi ? "is-invalid" : ""
              }`}
              value={formData.usoCfdi}
              onChange={(e) => handleFormChange("usoCfdi", e.target.value)}
            >
              <option value="" disabled>
                Selecciona...
              </option>
              <option value="opM">Opción M</option>
              <option value="opN">Opción N</option>
            </select>
            {submitted && !formData.usoCfdi && (
              <div className="invalid-feedback">Campo requerido</div>
            )}
          </div>

          <div className="col-md-3">
            <label className="fw-bold">Cuenta pago</label>
            <input
              type="text"
              className={`form-control ${
                submitted && !formData.cuentaPago ? "is-invalid" : ""
              }`}
              value={formData.cuentaPago}
              onChange={(e) => handleFormChange("cuentaPago", e.target.value)}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9.]/g, "")
                  .replace(/(\..*)\./g, "$1");
              }}
            />
            {submitted && !formData.cuentaPago && (
              <div className="invalid-feedback">Campo requerido</div>
            )}
          </div>

          <div className="col-md-3 mt-3 mt-md-0">
            <label className="fw-bold">Observaciones</label>
            <input
              type="text"
              className={`form-control ${
                submitted && !formData.observaciones ? "is-invalid" : ""
              }`}
              value={formData.observaciones}
              onChange={(e) =>
                handleFormChange("observaciones", e.target.value)
              }
            />
            {submitted && !formData.observaciones && (
              <div className="invalid-feedback">Campo requerido</div>
            )}
          </div>
        </div>

        {/* tercer fila (solo se muestran los datos de la guia en la tabla)*/}
        {billingDetails.length > 0 && (
            <div className="row">
              <div className="col-12 text-center">
                <table
                  className="table fondo-headBillingMonto mx-auto"
                  style={{ maxWidth: "700px", width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>Concepto</th>
                      <th>Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    {billingDetails.map((item, index) => (
                      <tr key={index}>
                        <td>{item.concepto}</td>
                        <td>{item.monto}</td>
                      </tr>
                    ))}
                    <tr>
                      <td className="text-center fw-bolder">Subtotal</td>
                      <td className="text-center">
                        {billingDetails
                          .reduce(
                            (sum, item) => sum + parseFloat(item.monto),
                            0
                          )
                          .toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-center fw-bolder">IVA 16%</td>
                      <td className="text-center">
                        {(
                          billingDetails.reduce(
                            (sum, item) => sum + parseFloat(item.monto),
                            0
                          ) * 0.16
                        ).toFixed(2)}
                      </td>
                    </tr>
                    <tr className="bor-bot">
                      <td className="text-center fw-bolder">Total</td>
                      <td className="text-center">
                        {(
                          billingDetails.reduce(
                            (sum, item) => sum + parseFloat(item.monto),
                            0
                          ) * 1.16
                        ).toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="row">
          <div className="btns mt-3 d-flex justify-content-end gap-3">
            <button className="btnn" onClick={handleGuardar}>
              Generar Factura
            </button>

            <button className="btnn" onClick={printTicket}>
                Ticket
              </button>
          </div>
        </div>

      </div>
    </>
  );
}

export default NewBilling;
